// Attempt to parse the colon-separated code into an object containing the user information.
export function tryRetrieveCodeValuesFromUrl(url: URL): RetrieveResult {
  try {
    const decodedCodeSearchParam = decodeCodeSearchParam(url);
    return tryRetrieveCodeValues(decodedCodeSearchParam);
  } catch {
    return { success: false };
  }
}

export function decodeCodeSearchParam(url: URL) {
  let cSearchParam = url.searchParams.get("c") || "";
  cSearchParam = cSearchParam.replace(/ /g, "+"); // Replace spaces again with '+' (they are converted while retrieving the param from URL)

  const binaryString = atob(cSearchParam);
  const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

// Attempt to parse the colon-separated code into an object containing the user information.
export function tryRetrieveCodeValues(input: string): RetrieveResult {
  const parts = input.split(":");
  if (parts.length !== 3) {
    return { success: false };
  }

  const username = parts[0];
  const code = parts[1];
  const mfaEnabled = parts[2].toLowerCase() === "true";
  return {
    success: true,
    data: { username, code, mfaEnabled },
  };
}

interface RetrieveResult {
  success: boolean;
  data?: CodeValues;
}

interface CodeValues {
  username: string;
  code: string;
  mfaEnabled: boolean;
}
